import type { ReactNode } from 'react'

export const imageStyles = ['horizontal', 'vertical', 'square'] as const

export type RailProps = {
  slug?: string
  items: {
    blocks: ReactNode[] | ReactNode
  }[]
  blocksTop?: {
    blocks: ReactNode[] | ReactNode
  }[]
  previewMode?: boolean
  builderBlock?: any
  stackOnMobile?: boolean
  stackOnDesktop?: boolean
  columnsDesktop?: number
  columnsMobile?: number
  imageStyle?: (typeof imageStyles)[number]
}
